module.exports = __webpack_public_path__ + "img/rogues-antholoty-ltc-city.16ec39ab.jpg";